import styles from './header.module.scss';
import { WideWidgetStyle } from '../wide/wide-widget-style';

export default class Header {
	public element:HTMLHeadingElement = document.createElement('div');

	constructor(text:string, className:WideWidgetStyle='default') {
		this.element.textContent = text;
		this.element.className = styles[className];
		this.element.dataset.nameSpace = 'dentolo';
	}
}